define('home/mixins/withViewFeedTracking',[
    'underscore',
    'core/bus',
], function (
    _,
    bus
) {
    'use strict';

    /**
     * Adds Disqus activity event tracking for initial feed view and subsequent
     * page loads.
     * Works with a FetchableCollectionView.
     */
    var withViewFeedTracking = function () {
        var _initialize = this.initialize;
        this.initialize = function () {
            _initialize.apply(this, arguments);

            // Track feed once initial fetch is complete (once we know whether the
            // feed is empty, error, or has content)
            this.listenTo(this, 'renderInitialContent', this.trackView);
        };

        /**
         * Tracks the initial feed view. This is done once after the initial fetch
         * is complete and the result is rendered to ensure that the user is currently
         * viewing the feed, and so we can determin if the feed is empty, or showing
         * an error, and add that information to the event.
         */
        this.trackView = function () {
            bus.trigger('viewFeed', this);

            // Listen to future page fetches to track page loads. This must
            // be deferred because a sync event may trigger for this initial
            // view and we don't want to track that as a subsequent page load.
            _.defer(_.bind(function () {
                this.listenTo(this.collection, 'sync', this.trackViewMore);
            }, this));
        };

        /**
         * Tracks loading subsequent pages of this feed.
         */
        this.trackViewMore = function () {
            bus.trigger('viewMoreFeed', this.getNumPages());
        };

        /**
         * Returns the number of pages that have been loaded for this collection.
         *
         * Override this if this view is not backed by a model which stores
         * numPages (such as a Feed model)
         * @returns {int}
         */
        this.getNumPages = function () {
            return this.model && this.model.get('numPages');
        };
    };

    return withViewFeedTracking;
});

